export default __webpack_public_path__ + "static/media/ap_v4_platform_mobile.2dc7054a.jpg";